import loadable from '@loadable/component';

export const OrgDashboardGradFairsLinksPageLoadable = loadable(
  () => import('./OrgDashboardGradFairsLinksPage'),
  { resolveComponent: (module) => module.OrgDashboardGradFairsLinksPage },
);
